<form [formGroup]="form" class="w-full" (ngSubmit)="onSubmit()">
  <button
    mat-button
    type="button"
    class="qaroni-close-icon !flex items-center justify-center"
    [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
  <div class="mat-mdc-dialog-title mb-2.5" i18n>Nuevo centro de trabajo</div>
  <mat-dialog-content>
    <div class="flex w-full flex-col gap-1">
      <mat-form-field appearance="outline">
        <mat-label i18n>Nombre</mat-label>
        <input matInput formControlName="name" autocomplete="off" type="text" />
        @if (InputValidation.checkInputErrors(name)) {
          <mat-error align="start">
            <qaroni-input-error-messages [fc]="name" />
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label i18n>Descripción</mat-label>
        <textarea
          matInput
          formControlName="description"
          class="resize-none"
          rows="3"></textarea>
        @if (InputValidation.checkInputErrors(description)) {
          <mat-error align="start">
            <qaroni-input-error-messages [fc]="description" />
          </mat-error>
        }
      </mat-form-field>

      <!-- EMAIL -->
      <mat-form-field appearance="outline">
        <mat-label i18n>Correo electrónico</mat-label>
        <input
          matInput
          formControlName="email"
          autocomplete="off"
          type="email" />
        @if (InputValidation.checkInputErrors(email)) {
          <mat-error align="start">
            <qaroni-input-error-messages [fc]="email" />
          </mat-error>
        }
      </mat-form-field>

      <!-- Timezone -->
      <mat-form-field appearance="outline">
        <mat-label i18n>Zona horaria</mat-label>
        <input
          matInput
          formControlName="timezone"
          type="text"
          [matAutocomplete]="auto" />
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          @for (
            timezone of timezones$ | async | timezoneFilter: timezone.value;
            track timezone
          ) {
            <mat-option [value]="timezone">
              {{ timezone }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (InputValidation.checkInputErrors(timezone)) {
          <mat-error align="start">
            <qaroni-input-error-messages [fc]="timezone" />
          </mat-error>
        }
      </mat-form-field>

      <mat-slide-toggle
        class="qaroni-slide-toggle mt-2"
        formControlName="hasAutomaticChecksClose"
        i18n>
        Admite cierre automático de fichajes
      </mat-slide-toggle>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <div class="flex items-center justify-center gap-2">
      <button
        mat-flat-button
        color="light-blue"
        class="qaroni-rounded-button"
        type="button"
        [mat-dialog-close]="false"
        i18n>
        Cancelar
      </button>
      <button
        mat-flat-button
        color="blue"
        class="qaroni-rounded-button"
        type="submit"
        [disabled]="!validatedForm">
        <mat-icon class="mr-1">save</mat-icon>
        <ng-container i18n>Guardar</ng-container>
      </button>
    </div>
  </mat-dialog-actions>
</form>
